<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xkfink/tc-custom/9781614480570.jpg?1705025862294" alt="This image is the cover for the book I'll Run With You"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">I'll Run With You
      </h1>
      <p class="bookDescription body article font2">
        <b>The Grammy-nominated musician and author of <i>Chasing the Wind</i> continues the joyous story of his life and the faith that has lifted him up along the way.</b><br/>  <br/> With frankness and an unwavering trust in God, William Chisum faces not only his own surgery, but his only son’s as well. Their story unfolds as they are enlightened and ignited and beat the physical odds, continuing their mission to share Christ’s love with their God-given musical abilities.<br/>  <br/> Chisum continues his journey ministering through song and testimony to those afflicted with physical hardships and mental anguish, helping them to continue on their path to a new and better life. With one song, Chisum captures the past and the future, in essence telling the grace-filled story of his own life.<br/>  <br/><i>I’ll Run With You</i> will give you the strength to put one foot in front of the other, no matter how many obstacles stand in your way. It will leave you joyously anticipating your greatest victory; the run that begins at Heaven’s gate and ends at the feet of the Father.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William Boyd Chisum
      </h2>
      
      <p class="authorDescription body article">William Boyd Chisum is an accomplished musician, singer, songwriter and author. His first book ""Chasing the Wind,"" an autobiography, was published by Morgan James Publishing in 2006. In 2007, Boyd received both the Grammy and Dove Award Nominations for his song, ""He Still Moves the Stone."" Boyd holds an Associate Degree in Sports Medicine/Orthopedic PA from Long Medical Institute. Boyd is a member of the National Association of Orthopedic Technologists, Gospel Music Association, Voting member of The Recording Academy (Grammy's), and resides with his wife and son in Dallas Texas.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1c170dd1